class UserInteractionsService {
  hasUserScrolledMoreThan (px) {
    return document.querySelector('.feed-header')?.getBoundingClientRect().top < -(px)
  }
}

export default new UserInteractionsService()
